module.exports = __webpack_public_path__ + "static/media/remote p.c0ea24e7.jpg";